// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"amountSliderMini_wrapper__xrHwL","slider":"amountSliderMini_slider__2b5zJ"};